import ClearIcon from '@mui/icons-material/Clear'
import { VALIDATION_AMOUNT } from '../../../components/utils/constant'
import CustomButton from '../ui/CustomButton'
import PaymentForm from './PaymentForm'

const DEFAULT_SUCCESS_MESSAGE =
  'Tarjeta registrada correctamente. El cobro de validacion sera devuelto automaticamente.'

const AddCardPaymentForm = ({
  amount = VALIDATION_AMOUNT,
  onSuccess,
  onProcessingChange,
  onClose,
  managedByParent = false,
  isProcessing = false,
  paymentTypeId = null,
  flowType = 'change_card',
  brickId = 'addCard',
  successMessage = DEFAULT_SUCCESS_MESSAGE
}) => (
  <div className='flex max-h-[80vh] w-[min(48rem,calc(100vw-2rem))] flex-col overflow-hidden rounded-xl bg-white shadow-2xl'>
    <div className='flex items-center justify-end bg-primary px-4 py-2 text-white sm:px-8'>
      {onClose && (
        <button
          type='button'
          onClick={onClose}
          className='rounded-full p-2 text-white transition-colors hover:bg-white/15'
          aria-label='Cerrar modal'
        >
          <ClearIcon style={{ fontSize: 20 }} />
        </button>
      )}
    </div>

    <div className='flex-1 overflow-y-auto px-6 py-8 sm:px-8'>
      <div className='mb-6 rounded-2xl border border-slate-200 bg-slate-50/80 p-5 shadow-sm'>
        <h2 className='text-2xl font-sans font-bold text-slate-800'>Agregar tarjeta</h2>
        <p className='mt-3 text-sm font-sans leading-6 text-slate-700'>
          Registraremos la tarjeta con un cobro de validacion que sera devuelto automaticamente.
        </p>
      </div>

      <div className='relative'>
        {managedByParent && isProcessing && (
          <div className='absolute inset-0 z-50 flex flex-col items-center justify-center rounded-[28px] bg-white/90 backdrop-blur-sm'>
            <div className='mb-4 h-16 w-16 animate-spin rounded-full border-b-4 border-t-4 border-accent1' />
            <h3 className='mb-2 text-xl font-sans font-bold text-gray-900'>Validando tarjeta</h3>
            <p className='text-center font-sans text-gray-600'>
              Por favor espera mientras registramos tu tarjeta.
            </p>
          </div>
        )}

        <PaymentForm
          amount={amount}
          flowType={flowType}
          saveCard
          managedByParent={managedByParent}
          paymentTypeId={paymentTypeId}
          onSuccess={onSuccess}
          onProcessingChange={onProcessingChange}
          brickId={brickId}
          successMessage={successMessage}
        />
      </div>
    </div>

    <div className='flex flex-wrap justify-end gap-3 border-t border-slate-200 bg-slate-50 px-6 py-4 sm:px-8'>
      {onClose && (
        <CustomButton
          type='button'
          title='Volver'
          onClick={onClose}
          color='primary'
          className='rounded-full px-5 py-2'
        />
      )}
    </div>
  </div>
)

export default AddCardPaymentForm
